import { getSessionPanelStorage } from '@shared/panels/panelSessionState';

export const KNOWLEDGE_LIBRARY_CARD_ZOOM_MIN_PERCENT = 100;
export const KNOWLEDGE_LIBRARY_CARD_ZOOM_MAX_PERCENT = 250;
export const KNOWLEDGE_LIBRARY_CARD_ZOOM_DEFAULT_PERCENT = 100;
export const KNOWLEDGE_LIBRARY_CARD_ZOOM_STEP_PERCENT = 10;

export const KNOWLEDGE_LIBRARY_KB_CARD_ZOOM_SESSION_KEY = 'knowledge-library.kb-card-zoom-percent';
export const KNOWLEDGE_LIBRARY_KV_CARD_ZOOM_SESSION_KEY = 'knowledge-library.kv-card-zoom-percent';

export const clampKnowledgeLibraryCardZoomPercent = (value: number): number => {
    if (Number.isNaN(value)) {
        return KNOWLEDGE_LIBRARY_CARD_ZOOM_DEFAULT_PERCENT;
    }

    return Math.min(
        KNOWLEDGE_LIBRARY_CARD_ZOOM_MAX_PERCENT,
        Math.max(KNOWLEDGE_LIBRARY_CARD_ZOOM_MIN_PERCENT, Math.round(value))
    );
};

export const loadKnowledgeLibraryCardZoomPercent = (key: string): number => {
    const storage = getSessionPanelStorage();
    const rawValue = storage?.getItem(key);
    return clampKnowledgeLibraryCardZoomPercent(rawValue ? Number(rawValue) : KNOWLEDGE_LIBRARY_CARD_ZOOM_DEFAULT_PERCENT);
};

export const saveKnowledgeLibraryCardZoomPercent = (key: string, value: number): number => {
    const normalizedValue = clampKnowledgeLibraryCardZoomPercent(value);
    const storage = getSessionPanelStorage();

    if (storage) {
        storage.setItem(key, String(normalizedValue));
    }

    return normalizedValue;
};